<template>
	<dashboard-dropdown-section
		:title="getLabel('companyProfessionalApplicationsReceivedTitle', 'Locum Applications')"
		type="practice-applications-received"
		:items-shown="5"
		:items="offers"
		event-name="load-applications-received"
		@load-applications-received="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'PracticeApplicationsReceived',

	components: { DashboardDropdownSection },

	data: () => ({
		offers: [],
	}),

	methods: {
		...mapActions('offers', ['FetchFilteredOffers']),

		async loadMore(event) {
			const { startDate, endDate } = event;

			const offersResults = await this.FetchFilteredOffers({ startDate, endDate, offersType: 'practice-applications-received' });
			this.offers = offersResults.map(set => ({ ...set, event_start_date: set.offer ? set.offer.date : set.availability.date }));
		},
	},
};
</script>
